import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

export interface IconOption {
  name: string;
  className: string;
}

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly ICONS_SCSS_PATH = 'assets/scss/abstracts/_icons.scss';

  constructor(private http: HttpClient) {}

  /**
   * Gets icon options from the SCSS file
   */
  getIconOptions(): Observable<IconOption[]> {
    return this.http.get(this.ICONS_SCSS_PATH, { responseType: 'text' }).pipe(
      map((content) => this.parseIconClasses(content)),
      catchError((error) => {
        console.error('Failed to load icons:', error);
        return of([]);
      })
    );
  }

  /**
   * Parses the content of the SCSS file to extract icon class names
   * @param content The content of the SCSS file as string
   */
  private parseIconClasses(content: string): IconOption[] {
    const iconRegex = /\.icon-([a-zA-Z0-9-]+):before\s*\{/g;
    const icons: IconOption[] = [];
    let match;

    while ((match = iconRegex.exec(content)) !== null) {
      const iconName = match[1];
      const displayName = iconName
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

      icons.push({
        name: displayName,
        className: `icon-${iconName}`,
      });
    }

    return icons;
  }
}
